import { render, staticRenderFns } from "./ImportDefects.vue?vue&type=template&id=7a584c33&"
import script from "./ImportDefects.vue?vue&type=script&lang=js&"
export * from "./ImportDefects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports